import React from "react";
import { Redirect, Route, Switch } from "polyrouter";
import AppRouter from "./AppRouter";
import FourOhFour from "./FourOhFour/FourOhFour";
import Verify from "routes/Verify/Verify";
import DownloadDesktop from "routes/DownloadDesktop/Download";
import FeedbackDesktop from "routes/FeedbackDesktop/Feedback";
import AppErrorBoundary from "./AppErrorBoundary";
import { ErrorPage, LoadingIndicator } from "elements";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router";
import { useDesktopUserOnly } from "../rbac";
import { useTranslation } from "utilities/i18n";
import { UnsubscribeNotifications, ConfirmNotifications } from "./Public";
import Error from "./Error/Error";

/**
 * The top level router, handles dealing with auth and unauth users.
 * @constructor
 */
const Routes: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth0();
  const { t } = useTranslation();
  const location = useLocation();
  const isDesktopUser = useDesktopUserOnly();

  return (
    <AppErrorBoundary errorComponent={<ErrorPage />}>
      <Switch key={"Routes"}>
        <Route path="/verify" component={Verify} />
        <Route path="/download" component={DownloadDesktop} />
        <Route path="/appfeedback" component={FeedbackDesktop} />
        <Route path="/unsubscribe" component={UnsubscribeNotifications} />
        <Route path="/confirm" component={ConfirmNotifications} />
        <Route path="/error" component={Error} />
        {isAuthenticated &&
          isDesktopUser &&
          !(location.pathname === "/accept-invite") && (
            <Redirect to="/download" />
          )}
        {isLoading && (
          <Route>
            <LoadingIndicator
              className="theme-independent"
              title={t("LOADING_AUTHENTICATION")}
            />
          </Route>
        )}
        <Route path="/" component={AppRouter} />
        <Route component={FourOhFour} />
      </Switch>
    </AppErrorBoundary>
  );
};

export default Routes;
